import { FuseOptionKey, IFuseOptions } from 'fuse.js'; // Replace 'path/to/FuseOptionKey' with the actual path to the 'FuseOptionKey' type.

/**
 * Constants used in the product center search component.
 */
const KeyWeights = {
  SCORE_1: 1,
  SCORE_2: 0.9,
  SCORE_3: 0.9,
  SCORE_4: 0.7,
  SCORE_5: 0.6,
  SCORE_6: 0.5,
};

interface ISearchWorkerConstants {
  SEARCH_KEYS: FuseOptionKey<string>[];
  ONE_TO_ONE_SEARCH_KEYS: string[];
  MessageType: {
    FUND_DATA: string;
    SEARCH_TERM: string;
  };
  FuseConfigOptions: IFuseOptions<any>;
}

export const Constants: ISearchWorkerConstants = {
  SEARCH_KEYS: [
    { name: 'productCode', weight: KeyWeights.SCORE_1 }, // 1:1 match
    { name: 'apir', weight: KeyWeights.SCORE_1 }, // 1:1 match
    { name: 'shareClassTerm', weight: KeyWeights.SCORE_4 }, // score 4
    { name: 'baseCurrencyName', weight: KeyWeights.SCORE_1 }, // score 6
    { name: 'fundName', weight: KeyWeights.SCORE_1 }, // score 1
    { name: 'vehicleTypeName', weight: KeyWeights.SCORE_3 }, // score 3
    { name: 'sfdrClassification' },
    { name: 'investmentStrategiesAssetClassName', weight: KeyWeights.SCORE_5 }, // score 5
    { name: 'investmentStrategiesRegionName', weight: KeyWeights.SCORE_2 }, // score 2
    { name: 'morningstarMedalistRating' },
    { name: 'isin', weight: KeyWeights.SCORE_1 }, // 1:1 match
  ],
  ONE_TO_ONE_SEARCH_KEYS: ['productCode', 'apir', 'isin'],
  MessageType: {
    FUND_DATA: 'FundData',
    SEARCH_TERM: 'SearchTerm',
  },
  FuseConfigOptions: {
    isCaseSensitive: false,
    includeScore: true,
    shouldSort: true,
    includeMatches: true,
    findAllMatches: false,
    minMatchCharLength: 1,
    location: 0,
    threshold: 0.0,
    distance: 10,
    useExtendedSearch: false,
    ignoreLocation: true,
    ignoreFieldNorm: false,
    fieldNormWeight: 1,
  },
} as const;
